import { useState, useEffect, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import GallerySection from "@/components/GallerySection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function HomePage() {
  return (
    <div className="min-h-screen bg-[#F7F4EC]">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <WhyChooseUs />
        <GallerySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

function AdminPage() {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("ozo_admin_token");
    if (!token) { setChecking(false); return; }
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdmin(data);
    } catch {
      localStorage.removeItem("ozo_admin_token");
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const handleLogout = () => {
    localStorage.removeItem("ozo_admin_token");
    setAdmin(null);
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-[#F7F4EC] flex items-center justify-center">
        <p className="text-[#4A627E] text-sm">Checking authentication...</p>
      </div>
    );
  }

  if (!admin) {
    return <AdminLogin onLogin={(data) => setAdmin(data)} />;
  }

  return <AdminDashboard admin={admin} onLogout={handleLogout} />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
